import { DefaultFuelSpec, FUEL_SPECS_STORE_ID } from '@navstation-portal/fuel-specs/data-model/fuel-spec';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const fuelSpecsEvents = eventGroup({
  source: FUEL_SPECS_STORE_ID,
  events: {
    fetchDefaultFuelSpecs: type<void>(),
    fetchDefaultFuelSpecsSuccess: type<DefaultFuelSpec[]>(),
    fetchDefaultFuelSpecsFailed: type<Error>(),
    rebuildFuelSpecLookup: type<void>(),
  },
});
